module.exports = new __parcel__URL__("storage_stars.09afa2c3.svg").toString();